import { createSlice } from '@reduxjs/toolkit'
import { StoreStatus } from 'common/utils/types'

import {
  getQuestionnaire,
  getQuestionnaireResults,
  postQuestionnaireResponse,
} from './questionnaires.service'
import { type Questionnaire, type QuestionnaireResults } from './questionnaires.types'

export interface QuestionnairesState {
  questionnaire: Questionnaire | null
  questionnaireStatus: StoreStatus
  questionnaireResults: QuestionnaireResults | null
  questionnaireResultsStatus: StoreStatus
  postQuestionnaireStatus: StoreStatus
}

const initialState: QuestionnairesState = {
  questionnaire: null,
  questionnaireStatus: StoreStatus.Idle,
  questionnaireResults: null,
  questionnaireResultsStatus: StoreStatus.Idle,
  postQuestionnaireStatus: StoreStatus.Idle,
}

export const QuestionnairesSlice = createSlice({
  name: 'questionnaires',
  initialState,
  reducers: {
    resetState: (state) => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(getQuestionnaire.pending, (state, { payload }) => ({
      ...state,
      questionnaireStatus: StoreStatus.Loading,
    }))
    builder.addCase(getQuestionnaire.fulfilled, (state, { payload }) => ({
      ...state,
      questionnaire: payload,
      questionnaireStatus: StoreStatus.Succeeded,
    }))
    builder.addCase(getQuestionnaire.rejected, (state) => ({
      ...state,
      questionnaire: null,
      questionnaireStatus: StoreStatus.Failed,
    }))
    builder.addCase(getQuestionnaireResults.pending, (state, { payload }) => ({
      ...state,
      questionnaireResultsStatus: StoreStatus.Loading,
    }))
    builder.addCase(getQuestionnaireResults.fulfilled, (state, { payload }) => ({
      ...state,
      questionnaireResults: payload,
      questionnaireResultsStatus: StoreStatus.Succeeded,
    }))
    builder.addCase(getQuestionnaireResults.rejected, (state) => ({
      ...state,
      questionnaireResults: null,
      questionnaireResultsStatus: StoreStatus.Failed,
    }))
    builder.addCase(postQuestionnaireResponse.pending, (state, { payload }) => ({
      ...state,
      postQuestionnaireStatus: StoreStatus.Loading,
    }))
    builder.addCase(postQuestionnaireResponse.fulfilled, (state, { payload }) => ({
      ...state,
      postQuestionnaireStatus: StoreStatus.Succeeded,
    }))
    builder.addCase(postQuestionnaireResponse.rejected, (state) => ({
      ...state,
      postQuestionnaireStatus: StoreStatus.Failed,
    }))
  },
})

export default QuestionnairesSlice.reducer
